<template>
    <div>
        <v-dialog v-model="$root.backupAlert" persistent no-click-animation max-width="600">
            <v-card>
                <v-card-title class="title noshadow redcolor font18 pr-0">
                    <v-icon class="redcolor mr-3">warning</v-icon>Data Backup is Pending
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pt-1 font16">
                    <div class="mt-4 mb-4">To backup go to <strong>Bizops Mobile App > Settings > Data Backup</strong></div>
                    <ul style="line-height: 24px;list-style-type: '\2713   ';">
                        <li class="mb-3"><strong>Data Protection:</strong> <span greencolor font-medium>Safeguards</span> against any data loss.</li>
                        <li class="mb-3"><strong>Peace of Mind:</strong> <span primary-color font-medium>Data Safety</span> reassurance.</li>
                        <li><strong>Easy Access:</strong> Facilitates quick data <span primary-color font-medium>Restoration</span>.</li>
                    </ul>

                    <div font12 class="pt-4 right-align" v-if="$root.lastBackupDate">Last Backup: {{ $root.lastBackupDate | moment("DD-MMM-YYYY hh:mm a")}}</div>

                    <v-alert type="info" :value="true" v-if="this.driveMessage" class="mt-4">{{ this.driveMessage }}</v-alert>
                </v-card-text>
                <v-card-actions style="padding-bottom: 16px;">
                    <v-layout ma-0 row wrap>
                        <!-- <v-flex xs12 sm12 md12 center-align pl-3 pr-3>
                            <v-btn font-heavy color="primary" block @click="gotoSetupDrive">Setup Now</v-btn>
                        </v-flex> -->
                        <!-- <v-flex xs12 sm12 md12 center-align pl-3 pr-3 mt-3 v-if="transactionCount < 10">
                            <v-btn font-heavy light-opacity-color flat block @click="fn_close">Skip</v-btn>
                        </v-flex> -->
                        <v-flex xs12 sm12 md12 right-align pr-3 font12 light-opacity-color>
                            <em>Press continue after backup</em>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align pl-3 pr-3 mt-3>
                            <v-btn capitalize color="primary" text @click="fn_redirectToWhatsApp"><v-icon class="primary-color font20 mr-2">help_outline</v-icon> Contact Support</v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align pl-3 pr-3 mt-3>
                            <v-btn capitalize color="primary" block @click="$root.fn_getLastBackupInfo">Continue <v-icon class="font20 ml-2">keyboard_arrow_right</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default{
	props:['gotoSetupDrive', 'message', 'skipAlert', 'transactionCount'],
	data(){	
		return{
			backupAlert: false,
            driveMessage: "Data backup is pending."
		}
	},
	methods: {
		openDialogWeb: function () {	
			this.backupAlert = true;
		},
		closeDialogWeb: function () {
            this.backupAlert = false;
		},
        fn_close: function(){
            if(this.skipAlert){
                this.skipAlert();
            }
            else{
                this.closeDialogWeb();
            }
        },
		fn_watchHelpVideo: function(){
			window.open('https://www.youtube.com/watch?v=Swi0dXEjHKk&list=PLlyT7aaJmsIsicHYhxa_JWGHA0RK41yuh');
		},
        fn_redirectToWhatsApp: function(){
          window.open("https://api.whatsapp.com/send?phone=918882741212");
        },
        fn_checkDataBackup: function(){
            this.driveMessage = null;
            if(this.$root.CurrentBusiness.DataDrive){
                this.$root.driveAlert = false;
            }
            else{
                setTimeout(() => {
                    this.driveMessage = "Data backup is pending!";
                }, 1000);
                // this.$eventHub.$emit('snackbarAlert', {msg:"Data drive is not set up yet."});
            }
        }
	}
}
</script>